import { ORDER_STATUS } from '../constant/DeliveryDefaultVar';

export const getColorStatus = status => {
  let statusCSS = '';

  switch (status) {
    case ORDER_STATUS.INIT_TRANS:
    case ORDER_STATUS.PAY_ACQUIRED:
    case ORDER_STATUS.DELIVERY_ORDER_CREATED:
    case ORDER_STATUS.PACKAGE_PICKED_UP:
      statusCSS = 'grey';
      break;
    case ORDER_STATUS.REQUEST_FOR_PICKUP:
    case ORDER_STATUS.SEARCH_FOR_DRIVER:
    case ORDER_STATUS.DRIVER_ENROUTE:
    case ORDER_STATUS.PACKAGE_IN_DELIVERY:
    case ORDER_STATUS.PACKAGE_IN_TRANSIT:
      statusCSS = 'orange';
      break;
    case ORDER_STATUS.PICKUP_REJECTED:
    case ORDER_STATUS.PICKUP_CANCELLED:
    case ORDER_STATUS.CANCELLED_BY_USER:
    case ORDER_STATUS.CANCELLED_BY_SYSTEM:
    case ORDER_STATUS.CANCELLED_BY_PARTNER:
    case ORDER_STATUS.DELIVERY_ORDER_RETURNED:
    case ORDER_STATUS.CANCEL_FAILED:
    case ORDER_STATUS.PACKAGE_IN_RETURN:
    case ORDER_STATUS.ORDER_EXPIRED:
      statusCSS = 'red';
      break;
    case ORDER_STATUS.PACKAGE_ARRIVED:
    case ORDER_STATUS.CANCEL_SUCCESS:
      statusCSS = 'green';
      break;
    default:
      statusCSS = '';
      break;
  }
  return statusCSS;
};

const filesUtil = { getColorStatus };
export default filesUtil;
